<template>
  <ul class="flex flex-col gap-1">
    <slot />
  </ul>
</template>
